import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AllMaterialModule } from "../../all-material.components";
import SharedModule from "../../shared/shared.module";
import { CoreModule } from "../../core/core.module";
import { ServicesModule } from "../../services/services.module";
import { FlexLayoutModule } from "@angular/flex-layout";
import { ComponentsModule } from "../../components/components.installer";
import { MatDatepickerModule } from "@angular/material";
import { MaterialTimeControlModule } from "angular-material-time-control";
import { UIRouterModule } from "@uirouter/angular";
import { OverviewComponent } from "./overview.component";
import { OverviewOptionsComponent } from "./overview-options.component";
import { OverviewTableComponent } from "./overview-table.component";
import { ActivitiesSharedModule } from "../shared/activities-shared.module";
import { RemarkDialog } from "./remark-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AllMaterialModule,
        SharedModule,
        CoreModule,
        ServicesModule,
        FlexLayoutModule,
        ComponentsModule,
        MatDatepickerModule,
        MaterialTimeControlModule,
        UIRouterModule,
        ActivitiesSharedModule,
        ReactiveFormsModule
    ],
    declarations: [
        OverviewComponent,
        OverviewOptionsComponent,
        OverviewTableComponent,
        RemarkDialog
    ],
    exports: [
        OverviewComponent
    ],
    entryComponents: [
        RemarkDialog
    ]
})
export class ActivityOverviewModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/overview/activity-overview.module.ts